document.addEventListener('DOMContentLoaded', function () {
  var mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
      var expanded = mobileToggle.getAttribute('aria-expanded') === 'true';
      mobileToggle.setAttribute('aria-expanded', String(!expanded));
    });
  }

  var cartDrawer = document.querySelector('[data-cart-drawer]');
  function getCartToggles() { return document.querySelectorAll('[data-cart-toggle]'); }
  function getCartClosers() { return document.querySelectorAll('[data-cart-close]'); }
  function openCart() { if (cartDrawer) cartDrawer.setAttribute('aria-hidden', 'false'); }
  function closeCart() { if (cartDrawer) cartDrawer.setAttribute('aria-hidden', 'true'); }
  function bindCartToggleEvents() {
    getCartToggles().forEach(function (btn) { btn.addEventListener('click', openCart); });
    getCartClosers().forEach(function (btn) { btn.addEventListener('click', closeCart); });
  }
  bindCartToggleEvents();

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count === 0) { el.setAttribute('hidden', ''); } else { el.removeAttribute('hidden'); }
    });
  }

  function refreshCartDrawer() {
    return fetch('/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        if (fresh && cartDrawer) {
          cartDrawer.replaceWith(fresh);
          cartDrawer = fresh;
          bindCartToggleEvents();
          bindQtyAndRemoveEvents();
        }
      });
  }

  function bindAddToCartEvents() {
    document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      if (btn.dataset.boundAddToCart) return;
      btn.dataset.boundAddToCart = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) {
          var formWrap = btn.closest('[data-product-form]');
          var hiddenIdEl = formWrap ? formWrap.querySelector('[data-selected-variant-id]') : null;
          if (hiddenIdEl && hiddenIdEl.value) variantId = hiddenIdEl.value;
        }
        if (!variantId) {
          var fallback = btn.getAttribute('data-fallback-url');
          if (fallback) { window.location.href = fallback; }
          return;
        }
        if (btn.disabled) return;
        var originalText = btn.textContent;
        var quantity = 1;
        var qtySelector = btn.getAttribute('data-quantity-input');
        var qtyEl = qtySelector ? document.querySelector(qtySelector) : null;
        if (!qtyEl) {
          var wrap = btn.closest('[data-product-form]');
          qtyEl = wrap ? wrap.querySelector('input[name="quantity"]') : null;
        }
        if (qtyEl && qtyEl.value) {
          var parsedQty = parseInt(qtyEl.value, 10);
          if (parsedQty > 0) quantity = parsedQty;
        }
        btn.disabled = true;
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Could not add to cart'); });
            return res.json();
          })
          .then(function () { return fetch('/cart.js'); })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            return refreshCartDrawer();
          })
          .then(function () {
            btn.disabled = false;
            btn.textContent = originalText;
            openCart();
          })
          .catch(function (err) {
            btn.textContent = 'Try again';
            console.error(err);
            setTimeout(function () { btn.disabled = false; btn.textContent = originalText; }, 1500);
          });
      });
    });
  }
  bindAddToCartEvents();

  function bindQtyAndRemoveEvents() {
    document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      if (input.dataset.boundQty) return;
      input.dataset.boundQty = '1';
      input.addEventListener('change', function () {
        var line = input.getAttribute('data-line');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: input.value })
        })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            return refreshCartDrawer();
          });
      });
    });

    document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      if (btn.dataset.boundRemove) return;
      btn.dataset.boundRemove = '1';
      btn.addEventListener('click', function () {
        var line = btn.getAttribute('data-line');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 })
        })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            return refreshCartDrawer();
          });
      });
    });
  }
  bindQtyAndRemoveEvents();
});
